import React from 'react';
import type {
  ListItemTextProps} from '@mui/material';
import {
  ListItemText as MuiListItemText
} from '@mui/material';

const ListItemText: React.FC<ListItemTextProps> = (props) => {
  return <MuiListItemText {...props} />;
};

export default ListItemText;
